// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"86":"5b8ed808","240":"bbbb8fce","644":"eb4a8677","929":"464bff15"}[chunkId] + ".js";
};